/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notificationcenter_Markasread3Inputs */

const en_notificationcenter_markasread3 = /** @type {(inputs: Notificationcenter_Markasread3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark as read`)
};

/**
* | output |
* | --- |
* | "Mark as read" |
*
* @param {Notificationcenter_Markasread3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const notificationcenter_markasread3 = /** @type {((inputs?: Notificationcenter_Markasread3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notificationcenter_Markasread3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_notificationcenter_markasread3(inputs)
});
export { notificationcenter_markasread3 as "notificationCenter_markAsRead" }